<template>
  <span :class="[compact ? 'caption' : 'body-2', 'font-weight-regular']" :style="{ color: configuracao.cor }">
    {{ configuracao.rotulo }}
  </span>
</template>

<script>
  export const coresPrioridade = Object.freeze({
    BAIXA: '#6fa77b',
    MEDIA: '#c4a342',
    ALTA: '#d5844d',
    URGENTE: '#cf6e6e'
  });

  const configuracoes = {
    BAIXA: { cor: coresPrioridade.BAIXA, rotulo: 'Baixa' },
    MEDIA: { cor: coresPrioridade.MEDIA, rotulo: 'Média' },
    ALTA: { cor: coresPrioridade.ALTA, rotulo: 'Alta' },
    URGENTE: { cor: coresPrioridade.URGENTE, rotulo: 'Urgente' }
  };

  const configuracaoPadrao = { cor: '#000000', rotulo: 'Não definida' };

  export default {
    name: 'StatusPrioridade',

    props: {
      prioridade: {
        type: String,
        default: ''
      },
      compact: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      configuracao() {
        return configuracoes[String(this.prioridade || '').toUpperCase()] || configuracaoPadrao;
      }
    }
  };
</script>
